import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getRecentPublicReports } from '../services/firestoreService';
import { formatInternationalDisplay } from '../utils/phoneCanonical';

function formatReportDate(createdAt) {
  const date = createdAt?.toDate?.() || (createdAt ? new Date(createdAt) : null);
  if (!date || Number.isNaN(date.getTime())) return '';
  return date.toLocaleDateString();
}

function RecentReports() {
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      try {
        const data = await getRecentPublicReports(10);
        if (!cancelled) setReports(data);
      } catch (err) {
        console.error('Failed to load recent reports:', err);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    load();
    return () => {
      cancelled = true;
    };
  }, []);

  if (loading) {
    return (
      <section className="mt-12 max-w-3xl mx-auto">
        <h2 className="text-2xl font-bold mb-4 text-center">Recent Reports</h2>
        <p className="text-center text-gray-500">Loading recent community reports…</p>
      </section>
    );
  }

  if (reports.length === 0) {
    return null;
  }

  return (
    <section className="mt-12 max-w-3xl mx-auto">
      <h2 className="text-2xl font-bold mb-2 text-center">Recent Reports</h2>
      <p className="text-center text-gray-600 mb-6 text-sm">
        Latest community reports from callers like you
      </p>
      <ul className="space-y-3">
        {reports.map((item) => (
          <li key={item.reportId}>
            <Link
              to={`/number/${item.phoneNumberId}`}
              className="block p-4 bg-white rounded-lg shadow hover:shadow-md transition border border-gray-100"
            >
              <div className="flex flex-wrap justify-between gap-2 mb-1">
                <span className="font-semibold text-blue-700">
                  {formatInternationalDisplay(item) || item.displayE164}
                </span>
                <span className="text-sm text-gray-500">{formatReportDate(item.createdAt)}</span>
              </div>
              <p className="text-sm font-medium text-gray-800">{item.categoryName}</p>
              {item.comment && (
                <p className="text-sm text-gray-600 mt-1 line-clamp-2">{item.comment}</p>
              )}
              {item.totalReports > 1 && (
                <p className="text-xs text-gray-400 mt-2">
                  {item.totalReports} total report{item.totalReports === 1 ? '' : 's'}
                </p>
              )}
            </Link>
          </li>
        ))}
      </ul>
    </section>
  );
}

export default RecentReports;
